export default __webpack_public_path__ + "static/media/mobile1.5a157d0a.png";